import { useQueryClient } from '@tanstack/react-query';

import { DAAS_COLLECTION_METADATA_CACHE, getQueryString } from '@pkg/hooks';

import { type UnifiedContractFormat } from '@app/client';
import { callGetCollectionMetadata } from '@app/client/resources/daas';

interface GetCollectionMetadataProps {
    contractAddresses?: UnifiedContractFormat[];
}
export function useGetCollectionMetadataByContract() {
    const queryClient = useQueryClient();
    return ({ contractAddresses }: GetCollectionMetadataProps) => {
        const customQuery = getQueryString({
            queryArrayKey: 'addresses',
            queryArray: contractAddresses?.sort(),
            queryParams: { include_slugs: true },
        });
        return queryClient.fetchQuery({
            queryKey: [DAAS_COLLECTION_METADATA_CACHE, customQuery],
            queryFn: ({ signal }) =>
                callGetCollectionMetadata({
                    type: 'contract',
                    settings: { signal },
                    customQuery,
                }),

            retry: false,
        });
    };
}
